const state = {
    checked: '1',
};

const mutations = {
    setChecked(state, value) {
        state.checked = value;
      },
};

const actions = {
    updateChecked({ commit }, value) {
        commit('setChecked', value);
      },
};

const getters = {
    // ...
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/checked.js